// EligibilityPanel.tsx

import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Center,
  Loader,
  MultiSelect,
  Button,
  Paper,
  Title,
  SimpleGrid,
  Card,
  Text,
  UnstyledButton,
  Select,
  Pagination,
  createStyles,
} from "@mantine/core";
import { IconCheck, IconCross, IconPlus, IconStar, IconX } from "@tabler/icons-react";
import Buttonfilter from "../../../assets/img/Icon Button.svg"; // Ensure this path is correct
import searchIcon from "../../../assets/img/searchIcon.svg"; // Ensure this path is correct
import CustomBreadcrumbs from "../../../components/CustomBreadCrumbs";
import { ServiceTag } from "../ServiceTag";
import { PatientNotFound } from "../../Patient/PatientVisits/DataNotFound";
import ProviderCards from "../requestCards";
import { useMedplum } from "@medplum/react";
const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    padding: "16px",
    marginTop: "16px",
  },
  breadCrumbs: {
    marginBottom: "50px",
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },

  loader: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },

  group: { justifyContent: "space-between", height: "30px", width: "100%" },
  box1: {
    display: "flex",
    flexDirection: "column",
  },
  Boxtitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  title: {
    fontWeight: 700,
    fontSize: "26px",
    lineHeight: "36px",
    color: "#262930",
  },
  subTitle: {
    fontWeight: 700,
    fontSize: "22px",
    lineHeight: "36px",
    color: "#262930",
  },
  subTitleBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
  },
  searchBar: {
    display: "flex",
    flexDirection: "row",
    gap: "24px",
    paddingTop: "24px",
    paddingBottom: "16px",
    alignItems: "center",
  },
  tagBox: {
    display: "flex",
    flexDirection: "row",
    gap: "14px",
    borderStyle: "solid",
    borderWidth: "2px",
    borderRadius: "4px",
    borderColor: "#9DCDF3",
    padding: "4px 12px 4px 12px",
    alignItems: "center",
  },
  suppLogoPverify: {
    height: "38px",
    width: "71px",
  },
  suppLogoAvaility: {
    height: "32px",
    width: "80px",
  },
  cardHeading: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "left",
    alignItems: "center",
    width: "100%",
    marginBottom: "16px",
  },
  iconBox: {
    height: "40px",
    width: "40px",
    borderRadius: 5,
    padding: 8,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#53A0DD",
  },
}));

interface EligibilityPanelProps {
  label?: any;
  isFilterModalOpen: boolean;
  setIsFilterModalOpen: (open: boolean) => void;
  isCreating: boolean;
  updatedServiceTypeMap: Array<{ value: string; label: string }>;
  handleFilterChange: (value: string[]) => void;
  filter: string[];
  handleApply: () => void;
  totalCERes: number;
  serviceType: string;
  navigate: (path: string) => void;
  patientList: Array<{ value: string; label: string }>;
  handleChange: (value: string | null) => void;
  onSearchChange: (value: string) => void;
  searchQuery: string;
  isPatientFetched: boolean;
  coverageData: any;
  mappedCResponseList: any[];
  handleClickDetails: (id: string) => void;
  searchLoader: boolean;
  currentPage: number;
  total: number;
  handlePageChange: (page: number) => void;
  nameOfComponent: any;
  totalRequest: any;
  itemComponent: any;
  rejected:any
  accepted:any
}

const EligibilityPanel: React.FC<EligibilityPanelProps> = ({
  nameOfComponent,
  isFilterModalOpen,
  setIsFilterModalOpen,
  isCreating,
  updatedServiceTypeMap,
  handleFilterChange,
  filter,
  handleApply,
  totalCERes,
  serviceType,
  navigate,
  patientList,
  handleChange,
  onSearchChange,
  searchQuery,
  isPatientFetched,
  coverageData,
  mappedCResponseList,
  handleClickDetails,
  searchLoader,
  currentPage,
  rejected,
  total,
  label,
  handlePageChange,
  totalRequest,
  itemComponent,
  accepted,
}) => {
  const { classes } = useStyles();

  return (
    <>
      <Modal
        opened={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        size="md"
        withCloseButton={false}
        closeOnEscape
        closeOnClickOutside
      >
        <Box sx={{ paddingTop: "20px", minHeight: "225px" }}>
          {isCreating ? (
            <Center className={classes.loader}>
              <Loader size="sm" />
            </Center>
          ) : (
            <MultiSelect
              data={updatedServiceTypeMap}
              label="Choose EHR type for filter"
              placeholder="Select filter"
              nothingFound="Nothing found"
              maxDropdownHeight={125}
              dropdownPosition="bottom"
              onChange={handleFilterChange}
              defaultValue={filter}
              clearable
            />
          )}
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            onClick={handleApply}
            disabled={filter.length === 0 || isCreating}
          >
            Apply
          </Button>
        </Box>
      </Modal>
      <Paper className={classes.default}>
        <Box>
          <Box className={classes.box1}>
            <Box className={classes.breadCrumbs}>
              <CustomBreadcrumbs />
              <ServiceTag serviceType={serviceType} />
            </Box>
            {isCreating ? (
              <Center className={classes.loader}>
                <Loader />
              </Center>
            ) : (
              <>
                <Box>
                  <Box className={classes.Boxtitle} mb={24}>
                    <Title className={classes.title}>{nameOfComponent}</Title>
                    <Box>
                      <Button
                        onClick={() => {
                          navigate(`new?service=availity`);
                        }}
                        sx={{ backgroundColor: "#1B75BC", width: "130px" }}
                      >
                        <IconPlus
                          size={"20px"}
                          style={{ marginRight: "6px" }}
                        />
                        Add New
                      </Button>
                    </Box>
                  </Box>
                  <SimpleGrid cols={3} spacing={24}>
                    <Card padding="lg" radius="md" withBorder>
                      <Box className={classes.cardHeading}>
                        <Box className={classes.iconBox} mr={12}>
                          <IconStar size={"22px"} color="#53A0DD" />
                        </Box>
                        Total Request
                      </Box>
                      <Text weight={600} ml={68} sx={{ fontSize: "28px" }}>
                        {totalRequest}
                      </Text>
                    </Card>
                    <Card padding="lg" radius="md" withBorder>
                      <Box className={classes.cardHeading}>
                        <Box className={classes.iconBox} mr={12}>
                          <IconStar size={"22px"} color="#53A0DD" />
                        </Box>
                        Accepted{" "}
                      </Box>
                      <Text weight={600} ml={68} sx={{ fontSize: "28px" }}>
                        {accepted}
                      </Text>
                    </Card>
                    <Card padding="lg" radius="md" withBorder>
                      <Box className={classes.cardHeading}>
                        <Box className={classes.iconBox} mr={12}>
                          <IconStar size={"22px"} color="#53A0DD" />
                        </Box>
                        Rejected{" "}
                      </Box>
                      <Text weight={600} ml={68} sx={{ fontSize: "28px" }}>
                        {rejected}
                      </Text>
                    </Card>
                  </SimpleGrid>

                  {/* Search Bar */}
                  <Box className={classes.subTitleBox}>
                    <Title className={classes.subTitle}>Requests</Title>
                    <Box className={classes.searchBar}>
                      <Box>
                        <UnstyledButton
                          onClick={() => setIsFilterModalOpen(true)}
                        >
                          <Box>
                            <img src={Buttonfilter} alt="Filter" />
                          </Box>
                        </UnstyledButton>
                      </Box>
                      <Box sx={{ maxWidth: "438px" }}>
                        <Select
                          icon={<img src={searchIcon} alt="Search" />}
                          placeholder="Search by keyword"
                          required
                          data={patientList}
                          rightSection={
                            isPatientFetched ? <Loader size={"sm"} /> : ""
                          }
                          size="lg"
                          radius="md"
                          clearable
                          onChange={handleChange}
                          sx={{
                            ".mantine-Select-itemsWrapper": {
                              paddingRight: "10px",
                            },
                          }}
                          searchable
                          onSearchChange={onSearchChange}
                          searchValue={searchQuery}
                          itemComponent={itemComponent}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>

                {searchLoader ? (
                  <Center
                    className={classes.loader}
                    style={{ paddingTop: "80%" }}
                  >
                    <Loader />
                  </Center>
                ) : (
                  <Box>
                    <Box pb={16}>
                      {coverageData.length === 0 ? (
                        <Center pt={60}>
                          <PatientNotFound patient={"Eligibility"} />
                        </Center>
                      ) : (
                        <>
                          <ProviderCards
                            providers={mappedCResponseList}
                            handleDetails={handleClickDetails}
                            labels={label}
                          />
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              marginTop: "18px",
                            }}
                          >
                            <Pagination
                              total={total}
                              onChange={handlePageChange}
                              defaultValue={currentPage}
                            />
                          </Box>
                        </>
                      )}
                    </Box>
                  </Box>
                )}
              </>
            )}
          </Box>
        </Box>
      </Paper>
    </>
  );
};

export default EligibilityPanel;
